;(function() {
  'use strict'

  angular.module('core.registerInterest', [])
})()
